export default __webpack_public_path__ + "static/media/medical_2.dd37256c.jpg";